<div class="cre-header-container">
  <div class="cre-layout-content">
    <div class="cre-header-slogan"></div>
  </div>
</div>
